






































import { Vue, Component, Prop } from "vue-property-decorator";
import DropdownPocket from "@share/common/drop-down/DropdownPocket.vue";
import { Status } from "../../status-bar/Status";
import { Modal } from "@common/Modal";
import { Element } from "@api/models/Element";

@Component({
  components: { DropdownPocket },
})
export default class SessionStateChanger extends Vue {

  @Prop({ required: true, default: Status.empty }) currentStatus: Status;
  @Prop({ required: true }) session: Element;

  addMinutes() {
    if(this.isBeginSoon || this.isNotStarted) {
      this.$emit('updateBeginTime', 5)
    }
    else if(this.isStarted || this.isEndSoon) {
      this.$emit('updateEndTime', 5)
    }
  }

  async start() {
    const text = this.isEnded ? this.$t("agenda.switchToManualMode").toString() : this.$t("agenda.startSessionConfirmTitle").toString()
    const confirmed = await this.doConfirm(text);
    if(confirmed) {
      this.isEnded ? this.$emit('setManualControl') : this.$emit('startSession');
    }
  }

  async end() {
    const confirmed = await this.doConfirm(this.$t("agenda.completeSessionConfirmTitle").toString());
    if(confirmed) {
      this.$emit('endSession');
    }
  }

  async toManual() {
    const confirmed = await this.doConfirm(this.$t("agenda.switchToManualMode").toString());
    if(confirmed) {
      this.$emit('setManualControl')
    }
  }

  async setOffsetToCurrentSessions() {
    const confirmed = await this.doConfirm(this.$t("agenda.shiftSessionTimeConfirm").toString());
    if(confirmed) {
      this.$emit('setOffsetToCurrentSessions');
    }
  }

  async doConfirm(title: string) {
    const modal = new Modal({
      title: title,
      buttons: [
        {
          text: this.$t('common.yes').toString(),
          class: 'is-green',
          returnValue: true
        },
        {
          text: this.$t('common.no').toString(),
          class: 'is-red is-outlined',
          returnValue: false
        },
      ]
    });

    const confirmed = await modal.showConfirm() as boolean | "close";

    return confirmed === 'close' ? false : confirmed;
  }


  get additionalText() {
    if(this.beginSoonOrStarted) {
      return this.isBeginSoon ? this.$t("agenda.beforeStart").toString().toLowerCase() : this.$t("agenda.toFinish").toString().toLowerCase()
    }
    else {
      return ""
    }
  }

  get addMinutesText() {
    return `${this.$t("agenda.addMinutes", { minutes: 5 })} ${this.additionalText}`;
  }

  get isBeginSoon() {
    return this.currentStatus === Status.beginSoon;
  }

  get isStarted() {
    return this.currentStatus === Status.started;
  }

  get isNotStarted() {
    return this.currentStatus === Status.notStarted;
  }

  get isEndSoon() {
    return this.currentStatus === Status.endSoon;
  }

  get isEnded() {
    return this.currentStatus === Status.ended
  }

  get startedOrEndSoon() {
    return this.isStarted || this.isEndSoon;
  }

  get beginSoonOrStarted( ) {
    return this.isBeginSoon || this.isStarted;
  }

  get startDisabled() {
    return this.startedOrEndSoon && this.session.isStarted || (this.isEnded && this.session.isManualControlled)
  }
}
